// CORE FUNCTIONALITY
// Opens and closes cards
function toggleCard(discovery_option) {
  discovery_option.classList.toggle("discovery_active");
}

function handleButtonClick(event) {
  // Prevent the click event from propagating to the card
  event.stopPropagation();
}

// Opens first card if screen is large
// Function to handle the actions based on screen size
/* disabled all because asked to make all cards open on load. To reverse: enable code below and remove "discovery_active" class from all in html

function handleResponsiveActions() {
  // Check if the screen size is larger than 990px
  if ($(window).width() > 989) {
    const prod1Element = document.querySelector(".discovery_prod-1");
    prod1Element.classList.toggle("discovery_active");
  }
}

*/

// Execute the responsive actions on page load
$(document).ready(function () {
  handleResponsiveActions();
});
